export default "__VITE_ASSET__6dd88274__"